import React from "react";
import StudentWorkSection from "../../components/StudentWorld/StudentWork.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const StudentWork: React.FC = () => {
  return (
    <div>
       <MetaComponent
        title="Student’s Work | Aptech Limited."
        desc="Explore exceptional projects and artworks by Aptech students in animation, VFX, and beauty and wellness. See their inspiring achievements and creative journeys."
        keywords="aptech student projects, aptech students work."
      />
      <StudentWorkSection />
    </div>
  );
}

export default StudentWork;
